'use client';

import { APP_VERSION } from '@payments-checkout/shared/helpers/constants/appVersion';
import { reportError } from '@payments-checkout/shared/observability';
import { useEffect } from 'react';

/**
 * Último recurso: `error.tsx` não captura erro do root layout. Substitui o root
 * layout, então renderiza `html`/`body` próprios e sem design system — se o erro
 * veio do layout, não há garantia de provider ou CSS.
 *
 * O português fixo é deliberado, apesar de o checkout ter seletor de idioma:
 * usar react-intl aqui reintroduziria dependência de provider exatamente no
 * boundary que existe para o caso de o provider ter quebrado.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Inline porque `RootProviders` não roda aqui.
    // eslint-disable-next-line no-console
    console.info('Build version:', APP_VERSION);

    reportError(error, {
      source: 'react_boundary',
      digest: error.digest,
      is_global: true,
      app_version: APP_VERSION,
    });
  }, [error]);

  return (
    <html lang="pt-BR">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          fontFamily: 'system-ui, sans-serif',
          padding: '24px',
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: '20px', margin: 0 }}>
          Estamos enfrentando alguns problemas
        </h1>
        <p style={{ margin: 0, color: '#555' }}>
          Atualize a página e tente novamente.
        </p>
        <button
          onClick={reset}
          style={{
            padding: '12px 24px',
            borderRadius: '8px',
            border: 0,
            background: '#111',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Tentar novamente
        </button>
      </body>
    </html>
  );
}
